module.exports = __webpack_public_path__ + "static/img/A135.fe7d2380.jpg";